document.addEventListener('DOMContentLoaded', () => {
  console.log('pro16-product-details.js loaded');
  console.log('window.__SUB_CONFIG__:', window.__SUB_CONFIG__);

  const btn = document.querySelector('form#add-to-cart button');
  const discountInput = document.querySelector('form#add-to-cart input[name="discount_code"]');
  
  // Variant selector functionality
  const variantBlocks = document.querySelectorAll('.ps-variation-block');
  const selectedColorSpan = document.getElementById('ps-selected-color');
  
  // Store swiper instance globally so we can access it
  let swiperInstance = null;
  
  // Wait for Swiper to be initialized
  setTimeout(() => {
    // Try to get the swiper instance
    const swiperElement = document.getElementById('product-image-swiper');
    if (swiperElement && swiperElement.swiper) {
      swiperInstance = swiperElement.swiper;
      console.log('Swiper instance found:', swiperInstance);
    }
  }, 500);
  
  // Handle variant selection
  variantBlocks.forEach(block => {
    block.addEventListener('click', () => {
      // Remove selected class from all variants
      variantBlocks.forEach(b => b.classList.remove('selected'));
      
      // Add selected class to clicked variant
      block.classList.add('selected');
      
      // Update selected color text
      const color = block.dataset.color;
      if (selectedColorSpan) {
        selectedColorSpan.textContent = color;
      }
      
      // Update variant ID in window.__SUB_CONFIG__ for the main product
      const variantId = parseInt(block.dataset.variantId);
      console.log('Selected variant:', variantId, 'Color:', color);
      
      // Update the first line item (main product) with the selected variant
      if (window.__SUB_CONFIG__ && window.__SUB_CONFIG__.lines && window.__SUB_CONFIG__.lines.length > 0) {
        const oldVariantId = window.__SUB_CONFIG__.lines[0].variantId;
        window.__SUB_CONFIG__.lines[0].variantId = variantId;
        
        // Update allowedPlans: copy the plan from old variant to new variant
        if (window.__SUB_CONFIG__.allowedPlans[oldVariantId]) {
          window.__SUB_CONFIG__.allowedPlans[variantId] = window.__SUB_CONFIG__.allowedPlans[oldVariantId];
        }
        
        console.log('Updated __SUB_CONFIG__ with variant:', variantId);
        console.log('Updated config:', window.__SUB_CONFIG__);
      }
      
      // Navigate swiper to the variant's featured image
      const imagePosition = parseInt(block.dataset.featuredImagePosition);
      if (swiperInstance && !isNaN(imagePosition)) {
        // Find the slide with matching position
        const slides = swiperInstance.slides;
        let targetSlideIndex = 0;
        
        slides.forEach((slide, index) => {
          const slidePosition = parseInt(slide.dataset.position);
          if (slidePosition === imagePosition) {
            targetSlideIndex = index;
          }
        });
        
        console.log('Navigating to slide index:', targetSlideIndex, 'for position:', imagePosition);
        swiperInstance.slideTo(targetSlideIndex);
      }
    });
  });
  
  // Set first variant as selected by default
  if (variantBlocks.length > 0) {
    variantBlocks[0].classList.add('selected');
  }

  console.log('Discount input found:', discountInput);
  console.log('Discount code value:', discountInput?.value);

  // If some script wrapped fetch, stash the native early in <head> as:
  // <script>window.__nativeFetch = window.fetch;</script>
  const fetchSafe = (...args) => (window.__nativeFetch || window.fetch)(...args);

  async function clearCart() {
    await fetchSafe('/cart/clear.js', { method: 'POST' });
  }


  function preflightValidate(config) {
    const { lines, allowedPlans } = config;
    const bad = [];

    for (const { variantId, planId } of lines) {
      const allowed = allowedPlans?.[variantId];
      if (Array.isArray(allowed) && !allowed.includes(planId)) {
        bad.push({ variantId, planId, reason: 'plan not allowed for variant (per Liquid dump)' });
      }
    }
    return bad;
  }

  async function addWithPlans(lines) {
    const items = lines.map(l => {
      const item = {
        id: l.variantId,
        quantity: l.qty || 1
      };

      // Only add selling_plan if it's not null (for one-time purchases)
      if (l.planId !== null) {
        item.selling_plan = l.planId;
      }

      return item;
    });

    const res = await fetchSafe('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      const text = await res.text();
      // Bubble up helpful messages you'll actually fix
      if (text.includes('Cannot find variant')) {
        throw new Error('Cannot find variant: one of your IDs is a *product* id, not a variant id.');
      }
      if (text.includes('selling_plan')) {
        throw new Error('Selling plan error: the specified plan is not available for at least one variant.');
      }
      throw new Error(`Add-to-cart failed: ${res.status} ${text}`);
    }
  }

  btn?.addEventListener('click', async (e) => {
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('add-to-cart-btn-spining');

    const CONFIG = window.__SUB_CONFIG__;

    // Safety check: ensure config exists
    if (!CONFIG || !CONFIG.lines) {
      alert('Configuration error: Cart setup is missing. Please refresh the page.');
      btn.disabled = false;
      btn.classList.remove('add-to-cart-btn-spining');
      return;
    }

    try {
      // 0) Optional—blockers/proxies must never intercept cart/checkout
      // If you have a fetch wrapper, short-circuit for /cart and /checkout here.

      // 1) Preflight validation
      const issues = preflightValidate(CONFIG);
      if (issues.length) {
        alert('A variant does not allow the selected selling plan.');
        return;
      }

      // 2) Start clean
      await clearCart();

      // 3) Add all lines with their selling plans
      await addWithPlans(CONFIG.lines);

      // 4) Proceed to checkout with discount code
      const code = (discountInput?.value || '').trim();
      console.log('Discount code:', code);

      if (code) {
        // Shopify discount URL format: /discount/CODE or /checkout/discount/CODE
        const checkoutUrl = `/checkout?discount=${encodeURIComponent(code)}`;
        console.log('Redirecting to:', checkoutUrl);
        window.location.href = checkoutUrl;
      } else {
        window.location.href = '/checkout';
      }
    } catch (err) {
      alert(err.message || 'Cart error occurred.');
    } finally {
      btn.disabled = false;
      btn.classList.remove('add-to-cart-btn-spining');
    }
  });
});

